import { Avatar, Box } from '@bechtel/gds';
import { MilestoneStatusCode } from '@bechtel/types';
import styled, { css } from 'styled-components';

interface PatternStyledProps {
  status: MilestoneStatusCode;
}

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

export interface QuantityStatsValuesStyledProps {
  backgroundColor?: string;
  color?: string;
}

export const BACKGROUND_COLORS = {
  planned: { light: '#e9eef5', dark: '#bdcde0' },
  claimed: { light: '#fef4e8', dark: '#fcddba' },
  approved: { light: '#eff3ef', dark: '#cedace' },
} as const;

export const ShiftBoxStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    height: 35px;
    padding: ${theme.spacings[300]} ${theme.spacings[450]} ${theme.spacings[300]} ${theme.spacings[500]};
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
    background-color: ${theme.colors.grey[100]};
  `}
`;

export const ShiftStatusTypeBoxStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  ${() => css`
    flex: 2;
  `}
`;

export const WorkPackageQuantityStatsStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  flexDirection: { sm: 'column' },
  alignContent: { sm: 'space-between' },
  gap: { sm: '450' },
})``;

export const WorkPackageQuantityStatsValueStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  gap: { sm: '300' },
})``;

export const WorkPackageOwnerComponentStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.grey['300']};
  `}
`;

export const UserItemStyled = styled(Box).attrs({
  pl: { sm: '500' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    flex: 4;
    color: ${theme.colors.black};
    min-height: 50px;
  `}
`;

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
  `}
`;

function getPatternColor({ status }: PatternStyledProps) {
  switch (status) {
    case MilestoneStatusCode.PLANNED:
      return css`
        background-color: ${({ theme }) => theme.colors.blue[500]};
      `;
    case MilestoneStatusCode.APPROVED:
      return css`
        background-color: ${({ theme }) => theme.colors.green[500]};
      `;
    case MilestoneStatusCode.CLAIMED:
      return css`
        background-color: ${({ theme }) => theme.colors.orange[500]};
      `;
    default:
      return css`
        background-color: ${({ theme }) => theme.colors.blue[500]};
      `;
  }
}

function getQuantityStatsColor({ backgroundColor, color }: QuantityStatsValuesStyledProps) {
  return css`
    color: ${color};
    background-color: ${backgroundColor};
  `;
}

export const QuantityStatsValuesStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})<QuantityStatsValuesStyledProps>`
  ${getQuantityStatsColor};
  ${() => `
      flex: 2;
      height: 50px;
  `}
`;

export const PatternStyled = styled.div<PatternStyledProps>`
  ${getPatternColor};

  ${({ theme }) => css`
    border-radius: ${theme.radii[100]};
    height: ${theme.fontSizes[500]};
    margin-right: ${theme.spacings[200]};
    width: ${theme.fontSizes[500]};
  `};
`;

export const OwnerTypeStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    height: 36px;
    padding: ${theme.spacings[200]} ${theme.spacings[600]} ${theme.spacings[400]} ${theme.spacings[500]};
    background-color: ${theme.colors.grey[200]};
  `}
`;

export const TotalHoursStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    flex: 4;
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.white};
  `}
`;

export const TotalHoursPerSfhitStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    padding-left: ${theme.spacings[500]};
    background-color: ${theme.colors.grey[100]};
  `}
`;

export const TWTotalHoursStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    padding-left: ${theme.spacings[500]};
    background-color: ${theme.colors.grey[100]};
    border-top: solid 1px ${theme.colors.grey['300']};
  `}
`;
